import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import cn from 'classnames';
import normalizeWheel from 'normalize-wheel';
import { ROOT_URL } from 'constants/Config';

import SpinnerImage from 'components/common/SpinnerImage';
import Filters from 'components/Building/Chess/Filters';
import About from 'components/Building/Chess/RightMenu/About/About';

import styles from './Gallery.scss';

import iconClose from 'assets/images/icons/cross.svg';


const MIN_SCALE = 1;
const MAX_SCALE = 5;
const WHEEL_FACTOR = 1.05;
const CLICK_FACTOR = 1.5;

class ChessGalleryPopup extends Component {


  constructor(props) {
    super(props);
    this.state = {
      hoverCellId: null,
      dragging: false,
      scale: 1,
      x: 0,
      y: 0,
      row: props.row,
      showFloorScroll: false
    };
  }

  isNegative = (n) => ((n = +n) || 1 / n) < 0

  handleMouseWheel = (e) => {
    e.preventDefault();
    const normalized = normalizeWheel(e);
    this.zoom(this.isNegative(normalized.pixelY), WHEEL_FACTOR);
  }

  zoom = (zoomIn, zoomFactor) => {
    const newScale = this.state.scale * (zoomIn ? zoomFactor : (1 / zoomFactor));

    this.setState({
      scale: Math.max(MIN_SCALE, Math.min(MAX_SCALE, newScale))
    });
  }

  zoomIn = () => {
    this.zoom(true, CLICK_FACTOR);
  }

  zoomOut = () => {
    this.zoom(false, CLICK_FACTOR);
  }

  handleZoomChange = (e) => {
    this.setState({
      scale: e.target.value
    });
  }

  handleZoomMouseDown = (e) => {
    e.stopPropagation();
  }

  getZoomPercent = () => (
    (this.state.scale - MIN_SCALE) / (MAX_SCALE - MIN_SCALE)
  )

  componentDidMount() {
    document.addEventListener('mousemove', this.handleMouseMove, false);
    document.addEventListener('mouseup', this.handleMouseUp, false);
    document.addEventListener('touchmove', this.handleTouchMove, false);
    document.addEventListener('touchend', this.handleMouseUp, false);
    window.addEventListener('resize', this.adjustFloorScroll);
  }

  componentWillUnmount() {
    document.removeEventListener('mousemove', this.handleMouseMove, false);
    document.removeEventListener('mouseup', this.handleMouseUp, false);
    document.removeEventListener('touchmove', this.handleTouchMove, false);
    document.removeEventListener('touchend', this.handleMouseUp, false);
    window.removeEventListener('resize', this.adjustFloorScroll);
  }

  adjustFloorScroll = (e) => {
    // this.setState({
    //   showFloorScroll: this.floors.clientHeight < this.floors.scrollHeight
    // })
  }

  handleTouchStart = (e) => {
    this.handleMouseDown(e.touches[0]);
  }

  handleMouseDown = (e) => {
    this.setState({ dragging: true });
    // Set coords
    this.coords = {
      x: e.pageX,
      y: e.pageY
    };
  }

  handleMouseUp = () => {
    this.setState({ dragging: false });
    this.coords = {};
  }

  handleTouchMove = (e) => {
    this.handleMove(e.touches[0]);
  }

  handleMouseMove = (e) => {
    if (!this.state.dragging) {
      return;
    }
    e.preventDefault();
    this.handleMove(e);
  }

  handleMove = (e) => {
    const xDiff = this.coords.x - e.pageX;
    const yDiff = this.coords.y - e.pageY;
    // Update to our new coordinates
    this.coords.x = e.pageX;
    this.coords.y = e.pageY;

    this.setState({
      x: this.state.x - xDiff,
      y: this.state.y - yDiff
    });
  }

  renderVectorOverlay({ all = false } = {}, rowData) {
    const { row, sectionCells, data: selected, pointers } = this.props;
    // const data = rowData;
    if (pointers) {
      const [width, height] = pointers.split(':');
      const coordinates = pointers.split(':')[2];
      const cs = coordinates.split(',');
      const path = cs.reduce(
        (path, c, i) => path.concat(i % 2 === 1 ? `${c} L ` : `${c} `), 'M '
      ).replace(/L $/, 'Z');
      return (
        <div className={styles.Plan}>
          <div className="lol">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height={height}
              width={width}
              viewBox={`0 0 ${width} ${height}`}
            >
              <g>
                <path
                  className={cn(
                styles.Flat,
                styles.SelectedFlat
              )}
                  d={path}
                />
              </g>
            </svg>
          </div>
        </div>
      );
    }
  }

  handleFloorClick = (row) => {
    this.setState({
      row
    });
  }

  handleNextFloorClick = (row) => {
    // this.floors.scrollTop += this.floors.clientHeight
  }

  handlePrevFloorClick = (row) => {
    // this.floors.scrollTop -= this.floors.clientHeight
  }

  renderRow = ({ name }, i) => {
    const disabled = this.props.sectionCells[i].cells.filter(
      cell =>
      cell && !cell.hidden && cell.pointers && cell.mark !== false
    ).length === 0;
    return (
      <div
        key={i}
        className={cn(styles.FloorItem, {
          [styles.Active]: i === this.state.row,
          [styles.Light]: disabled
        })}
        onClick={this.handleFloorClick.bind(this, i)}
      > { name } </div>
    );
  }

  render() {
    const {
      building, data: room, rows, client,
      sectionId, filters, pavilionsFlat, handleFilters,
      sectionCells, cells, isClientView, planId, floor, roomData,
      t
    } = this.props;
    const rowCells = sectionCells[this.state.row].cells.filter(cell => cell && cell.pointers);
    const [width, height] = ((rowCells[0] && rowCells[0].pointers) || '0:0').split(':');
    const { scale, x, y } = this.state;

    return (
      <div className={styles.PopUpOuter}>
        <div className={styles.PopUpInner}>
          <div className={styles.FloorPlanWrapper}>
            <div className={styles.FloorPlanTop}>
              {!isClientView ? <Filters
                pavilions={building.pavilions}
                pavilionsFlat={pavilionsFlat}
                filters={filters}
                handleFilters={handleFilters}
                search={filters}
                chessfilter="true"
                cells={cells}
              /> : <div className={styles.ModalName}>
                {t('components.flatsList.flatListItem.gallery.modalName')}
              </div>}
              <div className={styles.Close} onClick={this.props.onClose}>
                <img src={iconClose} alt="close" />
              </div>
            </div>
            {!isClientView && <div className={styles.FloorPlanLeft}>
              <div className={styles.SelectFloor}>
                {
                  this.state.showFloorScroll &&
                  <div
                    className={cn(styles.SelectFloorArrow, styles.Top)}
                    onClick={this.handlePrevFloorClick}
                  />
                }
                <div className={styles.Floors}>
                  {
                    rows.map(
                      this.renderRow
                    )
                  }
                </div>
                {
                  this.state.showFloorScroll &&
                  <div
                    className={cn(styles.SelectFloorArrow, styles.Bottom)}
                    onClick={this.handleNextFloorClick}
                  />
                }
              </div>
            </div>}
            {<div className={styles.FloorPlanRight}>
              <About
                data={{ data: roomData }}
                building={building}
                client={client}
                sectionId={sectionId}
                withImage={false}
                chessfilter
                isClientView
              />
            </div>}
            <div
              className={styles.FloorPlan}
              onWheel={this.handleMouseWheel}
              onMouseDown={this.handleMouseDown}
              onTouchStart={this.handleTouchStart}
              style={{
                cursor: this.state.dragging ? '-webkit-grabbing' : 'default'
              }}
            >
              <div className={styles.FloorTitle}>
                {t('components.flatsList.flatListItem.gallery.floor', { floor })}
              </div>
              {
                (isClientView || !!rowCells[0]) &&
                <div className={styles.ZoomButtons}>
                  <div onClick={this.zoomOut} className={cn(styles.ZoomBtn, styles.ZoomOut)}></div>
                  <input type="range" value={this.state.scale} step={0.01} min={MIN_SCALE} max={MAX_SCALE} onChange={this.handleZoomChange} onMouseDown={this.handleZoomMouseDown} />
                  <div onClick={this.zoomIn} className={cn(styles.ZoomBtn, styles.ZoomIn)}></div>
                </div>
              }
              <SpinnerImage
                key={this.state.row}
                className={styles.ImageInfo}
                // imageSrc={`${ROOT_URL}/image/plan?id=${rowCells[0] ? rowCells[0].planId : null}&preset=1000`}
                imageSrc={`${ROOT_URL}/image/plan?id=${planId || null}&preset=1000`}
                imageAlt="Room"
                spinner={<div className={styles.LoaderInfo} />}
                blur={this.props.isChessLoading}
                style={{
                  ...(
                    height && width && {
                      width: `${Math.min(69, 54 * width / height)}vmin`,
                      height: `${Math.min(54, 69 * height / width)}vmin`,
                      transform: `translate(${x}px, ${y}px) scale(${scale})`
                    }
                  ),
                  ...(
                    this.state.dragging &&
                    { transition: '0s' }
                  )
                }}
              >
                {this.renderVectorOverlay({ all: true }, rowCells[0]) }
              </SpinnerImage>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export const ChessGalleryPopupWithRouter = withRouter(ChessGalleryPopup);



// WEBPACK FOOTER //
// ./src/components/FlatsList/FlatsListItem/Gallery/Gallery.js